import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useHistory } from 'react-router-dom';
import { Box, Button, Column, Row, Spinner, TextButton, Typography } from 'seagull';
import { AnchorLogo } from 'seagull/icons';
import { routes } from '~/constants';
import styles from './NotificationActionLayout.module.scss';
export var NotificationActionLayoutType = /*#__PURE__*/ function(NotificationActionLayoutType) {
    NotificationActionLayoutType["Loading"] = "loading";
    NotificationActionLayoutType["BeforeAction"] = "beforeAction";
    NotificationActionLayoutType["AfterAction"] = "afterAction";
    return NotificationActionLayoutType;
}({});
const NotificationActionLayout = (param)=>{
    let { state, hideSignInLink = false } = param;
    const history = useHistory();
    const handleRedirectToSignInPage = ()=>{
        history.push(routes.home);
    };
    if (state.type === "loading") {
        return /*#__PURE__*/ _jsx(Spinner, {
            testId: "spinner",
            centeredInBox: true,
            centerBoxHeight: "100%"
        });
    }
    return /*#__PURE__*/ _jsxs(Column, {
        className: styles.notificationActionContainer,
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        children: [
            hideSignInLink && /*#__PURE__*/ _jsx(Box, {
                className: styles.logoContainer,
                testId: "notification-action-logo-container",
                children: /*#__PURE__*/ _jsx(AnchorLogo, {
                    theme: "dark",
                    height: 56
                })
            }),
            state.type === "afterAction" ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h3",
                        weight: "normal",
                        testId: "notification-action-header-text",
                        children: state.afterAction.header
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        className: styles.description,
                        variant: "h5",
                        testId: "notification-action-description-text",
                        children: state.afterAction.notificationDescription
                    })
                ]
            }) : /*#__PURE__*/ _jsxs(Column, {
                gap: 36,
                children: [
                    typeof state.beforeAction.header === 'string' ? /*#__PURE__*/ _jsx(Typography, {
                        variant: "h5",
                        weight: "normal",
                        testId: "notification-before-action-header-text",
                        children: state.beforeAction.header
                    }) : state.beforeAction.header,
                    /*#__PURE__*/ _jsx(Row, {
                        justifyContent: "center",
                        children: /*#__PURE__*/ _jsx(Button, {
                            bi: {
                                name: 'notification_action'
                            },
                            testId: "approve-action-button",
                            onClick: state.beforeAction.onClick,
                            size: "large",
                            children: state.beforeAction.buttonText
                        })
                    })
                ]
            }),
            !hideSignInLink && /*#__PURE__*/ _jsxs(Typography, {
                variant: "h5",
                className: styles.footer,
                children: [
                    /*#__PURE__*/ _jsx(TextButton, {
                        bi: {
                            name: 'open_notification_sign_in'
                        },
                        variant: "h5",
                        testId: "notification-action-sign-in-link",
                        onClick: handleRedirectToSignInPage,
                        children: "Click here"
                    }),
                    "to sign in to",
                    /*#__PURE__*/ _jsx(AnchorLogo, {
                        theme: "dark",
                        height: 56
                    })
                ]
            })
        ]
    });
};
export default NotificationActionLayout;
